import { Row, Col, Card, Table, Button, Modal, Select, Input } from "antd";
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { useLocation, useNavigate, useParams } from "react-router";
const { Option } = Select;
const ColoumUpdation = () => {
  const { request } = useRequest();
  const [data, setData] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  // Fetch data from the API
  useEffect(() => {
    request({
      url: `/common/db-coloum`,
      method: "GET",
      onSuccess: (data) => {
        console.log(data.data.data[0]);
        setData(data.data.data[0]);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  }, []);

  // Handle input change
  const handleInputChange = (category, index, value) => {
    setData((prevData) => ({
      ...prevData,
      [category]: prevData[category].map((item, i) =>
        i === index ? value : item
      ),
    }));
  };

  // Save updated data
  const handleSave = async () => {
    console.log(data, "value");
    try {
      request({
        url: `/common/update-coloum`,
        method: "PUT",
        data: data,
        onSuccess: (data) => {
          setIsEditing(false);
          ShowToast("Data Updated Successfully", Severty.SUCCESS);
        },
        onError: (error) => {
          ShowToast(error, Severty.ERROR);
        },
      });
      // await axios.put('/api/coloums', data);  // Send updated data to the server

      // alert('Data updated successfully');
    } catch (error) {
      console.error("Error updating data", error);
    }
  };

  const columns = [
    {
      title: "Column",
      dataIndex: "category",
      key: "category",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Values",
      dataIndex: "values",
      key: "values",
      render: (values, { category }) => (
        <div>
          {values?.map((value, index) => (
            <div
              key={index}
              style={{ marginBottom: "8px" }}
              className="main-new-remove-and-input"
            >
              {isEditing ? (
                <Input
                  value={value}
                  onChange={(e) =>
                    handleInputChange(category, index, e.target.value)
                  }
                  style={{ marginRight: "8px", width: "80%" }}
                />
              ) : (
                <span>{value}</span>
              )}
              {isEditing && (
                <Button
                  type="danger"
                  onClick={() =>
                    setData((prevData) => ({
                      ...prevData,
                      [category]: prevData[category].filter(
                        (_, i) => i !== index
                      ),
                    }))
                  }
                  style={{ marginLeft: "8px" }}
                >
                  Remove
                </Button>
              )}
            </div>
          ))}
        </div>
      ),
    },
  ];

  const tableData = data
    ? Object.keys(data).map((category) => ({
        key: category,
        category,
        values: data[category],
      }))
    : [];

  return (
    <Main>
      <Row>
        <Col span={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Editable Table"
          >
            <div className="table-responsive table-responsive-scrollbar">
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={false}
                bordered
                sticky
                scroll={{ y: 600 }}
                style={{ width: "100%", textAlign: "left" }}
              />
            </div>
            <div style={{ marginTop: "16px" }}>
              <Button
                type="primary"
                onClick={() => setIsEditing(!isEditing)}
                style={{ marginRight: "8px" }}
              >
                {isEditing ? "Cancel" : "Edit"}
              </Button>
              {isEditing && (
                <Button type="primary" onClick={handleSave}>
                  Save
                </Button>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    </Main>
  );
};

export default ColoumUpdation;
